/*  Shared  */
import { Route } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { Link, useParams } from 'react-router';

/**
 * A component that creates a link to run a report with specified parameters
 * @param {Object} props - The component props
 * @param {string[]} [props.breachSelection] - Array of selected breach IDs to filter the report
 * @param {React.ReactNode} props.children - Child elements to render inside the link
 * @param {string} [props.clientSelection] - Selected client ID to filter the report
 * @param {string} props.period - Time period for the report
 * @param {string} props.reportType - Type of report to run
 * @param {boolean} [props.run] - Whether to automatically run the report
 * @param {number} [props.startTime] - Start time for the report period in milliseconds
 * @param {string | number[]} [props.userSelection] - Selected user ID to filter the or [0]
 */
export const RunReportLink = ({
    breachSelection,
    children,
    clientSelection,
    period,
    reportType,
    run,
    startTime,
    userSelection
}: {
    breachSelection?: string[];
    children: React.ReactNode;
    clientSelection?: string;
    period: string;
    reportType: string;
    run?: boolean;
    startTime?: number;
    userSelection?: string | number[];
}) => {
    const { clientId, partnerId } = useParams();
    const route = Route.buildBaseReportsRoute({ clientId, partnerId });

    let url = `${route}?`;
    if (startTime) {
        url += `startTime=${startTime}&`;
    }
    if (userSelection) {
        url += `userSelection=${userSelection}&`;
    }
    if (period) {
        url += `period=${period}&`;
    }
    if (reportType) {
        url += `reportType=${reportType}&`;
    }
    if (run) {
        url += `run=${run}&`;
    }
    if (breachSelection) {
        url += `breachSelection=${breachSelection}&`;
    }
    if (clientSelection) {
        url += `clientSelection=${clientSelection}&`;
    }
    if (clientId) {
        url += `platformTenantId=${clientId}&`;
    }

    return (
        <Link className="link" to={url} data-testid="runReportLink">
            {children}
        </Link>
    );
};
